import * as React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export const VpBillingToggleButton = ({
  billingPeriod,
  billingPeriodHandler,
  firstOption,
  secondOption
}) => {
  return (
    <ToggleButtonGroup
      color="primary"
      value={billingPeriod}
      exclusive
      onChange={billingPeriodHandler}
      aria-label="text alignment"
      sx={{ mt: '22px' }}
    >
      <ToggleButton value={firstOption} aria-label="Monthly Billing">
        {firstOption}
      </ToggleButton>
      <ToggleButton value={secondOption} aria-label="Annual Billing">
        {secondOption}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

VpBillingToggleButton.propTypes = {
  billingPeriod: PropTypes.string.isRequired,
  billingPeriodHandler: PropTypes.func.isRequired,
  firstOption: PropTypes.string.isRequired,
  secondOption: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpBillingToggleButton.jsx